import { useMemo } from "react"
import { useQueries } from "@tanstack/react-query"
import { map } from "lodash"

// Works around https://github.com/TanStack/query/issues/8224
// by combining identical queries, then re-spreading the results
export default function useCombinedQueries(initialQueries, initialCombine) {
  const [queries, combine] = useMemo(() => {
    // A map of each unique query to run, and it's index in the consolidatedQueries array
    const keyIndexes = {}
    // An array of all the unique queries to run
    const consolidatedQueries = []
    // For each initial query index, the index of the corresponding result
    const initialQueriesResultIndex = []

    for (let queryIndex = 0; queryIndex < initialQueries.length; queryIndex++) {
      const query = initialQueries[queryIndex]
      if (!query) {
        initialQueriesResultIndex.push(-1)
      } else {
        const stringKey = JSON.stringify(query.queryKey)
        if (keyIndexes[stringKey] === undefined) {
          keyIndexes[stringKey] = consolidatedQueries.length
          initialQueriesResultIndex.push(consolidatedQueries.length)
          consolidatedQueries.push(query)
        } else {
          initialQueriesResultIndex.push(keyIndexes[stringKey])
        }
      }
    }

    const combine = results => {
      const spreadResults = map(initialQueriesResultIndex, queryIndex => {
        return queryIndex === -1 ? null : results[queryIndex]
      })
      return initialCombine(spreadResults)
    }

    return [consolidatedQueries, combine]
  }, [initialQueries, initialCombine])

  return useQueries({
    queries,
    combine,
  })
}
